<template>
  <div>
    <div class="menu pointer" @click="toggleNav">
      <svg preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 120 120">
        <line stroke-linecap="round" x1="10" y1="30" x2="110" y2="30" stroke-width="20" stroke="black"/>
        <line stroke-linecap="round" x1="10" y1="60" x2="110" y2="60" stroke-width="20" stroke="black"/>
        <line stroke-linecap="round" x1="10" y1="90" x2="110" y2="90" stroke-width="20" stroke="black"/>
      </svg>
    </div>
    <slide-transition :direction="'left'">
      <nav v-if="showSideNav" class="flex-column fullscreenme">
        <div class="d-flex justify-content-between top-bar align-items-center border-bottom-1">
          <a class="nav-link dashboard smash-right" @click.prevent="toggleNav">close</a>
        </div>
        <a v-for="(link, index) in navLinks" v-if="link.show" :key="index" class="nav-link nav-link--mobile" v-bind:href="extractHref(link)" @click="callback(link, $event)">{{ link.name }}</a>
      </nav>
    </slide-transition>
  </div>
</template>

<script>
export default {
  name: 'HamburgerNav',
  props: {
    navLinks: {
      type: Array,
      required: true
    },
    showSideNav: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    toggleNav () {
      this.$emit('update:showSideNav', !this.showSideNav)
    },
    extractHref (link) {
      if (link.href === null || typeof link.href === 'undefined') return '#'
      return this.$sbAppSettings.photoPrint(link.href)
    },
    callback (link, e) {
      const callback = link.callback
      if (callback === null || typeof callback === 'undefined') return
      else if (typeof callback === 'function') {
        e.preventDefault()
        callback(e)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .border-bottom-1 {
    border-bottom: 1px solid;
  }
  .smash-right {
    margin-left: auto;
  }
  .pointer {
    cursor: pointer;
  }
  .fullscreenme {
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(255,255,255,0.95);
    z-index: 1;
    width: 100%;
    height: 100%;
  }
  .full-svg {
    height: 100%;
    width: 100%;
  }
  .menu {
    // min-width: 10em;
    height: 2em;
    width: 2em;
    align-items: center;
  }
  .top-bar {
    height: 4em;
  }
  .nav-link--mobile {
    padding: 1em;
    border-bottom: 1px solid;
    border-radius: 0;
  }

  .slide-left-enter-active, .slide-left-leave-active {
    transition: all .3s ease;
  }
  .slide-left-enter, .slide-left-leave-to {
    transform: translateX(-10px);
    opacity: 0;
  }
</style>
